/**
 * Configuração do chat por ambiente, lida em runtime.
 *
 * Uma imagem do frontend serve os três ambientes da homologação (chat,
 * chat-marcus, chat-will). Na subida, o nginx grava `/runtime-config.js` com
 * `window.__SF_CHAT_CONFIG__` (ver `docker/40-chat-runtime-config.sh`). O que
 * vier ali vence o valor do build; campo ausente ou vazio cai no build.
 */
export const CHAT_CONFIG_GLOBAL = "__SF_CHAT_CONFIG__";

export type ChatConfig = {
  VITE_APP_API_BASE_URL?: string;
  VITE_APP_ORIGINS?: string;
};

const CAMPOS = ["VITE_APP_API_BASE_URL", "VITE_APP_ORIGINS"] as const;

function texto(v: unknown): string | undefined {
  return typeof v === "string" && v.trim() ? v.trim() : undefined;
}

export function resolveChatConfig(runtime: unknown, build: ChatConfig): ChatConfig {
  const r = runtime && typeof runtime === "object" ? (runtime as Record<string, unknown>) : {};
  const saida: ChatConfig = {};
  for (const campo of CAMPOS) saida[campo] = texto(r[campo]) ?? texto(build[campo]);
  return saida;
}

/** A configuração vigente na página: runtime (`window`) sobre o build. */
export function chatConfig(): ChatConfig {
  const global = typeof window === "undefined" ? undefined : (window as unknown as Record<string, unknown>)[CHAT_CONFIG_GLOBAL];
  return resolveChatConfig(global, {
    VITE_APP_API_BASE_URL: import.meta.env.VITE_APP_API_BASE_URL,
    VITE_APP_ORIGINS: import.meta.env.VITE_APP_ORIGINS,
  });
}
